import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyDays]',

})
export class OnlyDaysDirective {

  constructor() { }
  @HostListener('input', ['$event'])
  onInputChange(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    const originalValue = input.value;

    let cleaned = originalValue.replace(/\D/g, '');

    cleaned = cleaned.substring(0, 4);

    if (cleaned !== originalValue) {
      input.value = cleaned;
      input.dispatchEvent(new Event('input'));
    }
  }

}
